<script lang="ts">
	import { ThinArrow } from '@icons';
	import type { ImageData } from '$lib/tools/cms';
	import { DatoImage } from '@atoms';
	import { Carousel } from '$lib/builders/carousel/Carousel.svelte';

	let { images }: { fullbleed: boolean; images: ImageData[] } = $props();

	// NOTE: Duplicate images to create an endless carousel
	// TODO: This should be done based on the carousel combined size of the items compared to the container
	// For the endless carousel to work properly, we need at least the container width + the biggest item width
	// For now, we just duplicate the images 3 times, so we know that there are at least 3 images to show on screen.
	const endlessImages = [...images, ...images, ...images];

	const carousel = Carousel.from<ImageData>(endlessImages, {
		drag: true,
		snap: true
	});

	const currentImageIndex = $derived(carousel.state.index % images.length);
	const currentImage = $derived(images[currentImageIndex]);
</script>

<section class="block:gallery block:large">
	<button class="prev button:round-inverted" onclick={carousel.prev}>
		<ThinArrow />
	</button>

	<div class="gallery-container" use:carousel.useContainer {...carousel.attr.container}>
		{#each carousel.items as image}
			{#if image.data.responsiveImage}
				<div class="img-container" use:image.useItem {...image.attr}>
					<DatoImage responsiveImage={image.data.responsiveImage} />
				</div>
			{/if}
		{/each}
	</div>
	<p class="info">
		<span class="image-index text:xs">
			{currentImageIndex + 1} af {images.length}
		</span>
		{#if currentImage?.responsiveImage?.title}
			{#if currentImage.responsiveImage.title.length > 50}
				<span class="image-caption text:xs"> -</span>
			{/if}
			<span class="image-caption text:xs"> {currentImage?.responsiveImage?.title ?? ''}</span>
		{/if}
	</p>

	<button class="next button:round-inverted" onclick={carousel.next}>
		<ThinArrow />
	</button>
</section>

<style lang="scss">
	section {
		position: relative;
		overflow: hidden;
		@include fullBleedBlock;

		&:last-child {
			margin-bottom: var(--spacing-auto);
		}
	}

	.gallery-container {
		height: 430px;
		width: 100%;
		overflow: hidden;
		padding-left: var(--gutter);

		@include md {
			padding-left: 0;
			margin-left: cols(12, 1, true, true);
			height: 615px;
		}
	}

	.info {
		grid-column: 2 / -2;
		padding-top: $gap4;
		margin-left: var(--gutter);
		width: cols(12, 12);
		color: $colorForeground;

		@include md {
			margin-left: cols(12, 1, true, true);
		}
	}

	.img-container {
		height: 100%;
		padding-right: var(--gap);
	}

	button {
		position: absolute;
		top: 50%;
		right: var(--gap);
		transform: translateY(-50%);
		z-index: 2;
		filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));

		&.prev {
			right: unset;
			left: var(--gap);

			:global(path) {
				transform: rotate(180deg);
				transform-origin: 50% 50%;
			}
		}

		:global(svg) {
			width: 0.4em;
		}
	}
</style>
